/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sonstigevermerke1Inputs */

const de__field_sonstigevermerke1 = /** @type {(inputs: _Field_Sonstigevermerke1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sonstige Vermerke`)
};

/**

* @param {_Field_Sonstigevermerke1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sonstigevermerke1 = /** @type {((inputs?: _Field_Sonstigevermerke1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sonstigevermerke1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_sonstigevermerke1(inputs)
});
export { _field_sonstigevermerke1 as "_field_sonstigeVermerke" }